import {FaLock, FaLockOpen} from 'react-icons/fa';
import DeleteItemIcon from "../../../assets/delete-item.svg";
import EditItemIcon from "../../../assets/edit-item.svg";
import {useState} from "react";
import dynamicAPI from "../../../api/dynamicAPI";
import SortableTh from "../../shared/SortableTh";

const renderMethodBadge = (color, method, permission) => {
    return (
        permission.method === method && (
            <span className={`badge bg-${color} px-2`}>{permission.method}</span>
        )
    );
};

const ViewPermissions = ({
                             data,
                             sort,
                             order,
                             onSort,
                             editHandler,
                             deleteHandler,
                             fetchPermissionsAgain,
                             groups,
                             groupFilter,
                             setGroupFilter,
                         }) => {

    const [isSyncing, setIsSyncing] = useState(false);

    const handleSyncPermissions = async () => {
        const confirmed = window.confirm(
            "Are you sure you want to reinitiate permissions?"
        );
        if (!confirmed) return;

        try {
            setIsSyncing(true);
            const result = await dynamicAPI('post', '/api/auth/reinitiate-permissions/');

            const roleLines = Array.isArray(result.provisionedRoles) && result.provisionedRoles.length
                ? `\nRoles: ${result.provisionedRoles.map((r) => `${r.name} — ${r.status}`).join(', ')}`
                : '';
            const authLine = result.authFixedCount
                ? `\n${result.authFixedCount} permission(s) corrected to the right Admin/Public value.`
                : '';
            alert(
                `Permissions Sync Completed. ${result.createdCount} new permissions added.${authLine}${roleLines}`
            );

            if (fetchPermissionsAgain) {
                fetchPermissionsAgain();
            }
        } catch (error) {
            console.error(error);
            alert(error.error || "Error syncing permissions.");
        } finally {
            setIsSyncing(false);
        }
    };


    return (
        <div className='table-responsive bg-light p-3 mt-2'>
            <button
                className="btn btn-warning btn-sm"
                onClick={handleSyncPermissions}
                disabled={isSyncing}
            >
                {isSyncing ? (
                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"/>
                ) : (
                    'Reinitiate Permissions'
                )}
            </button>
            <div className='d-flex gap-2 align-items-center my-2 flex-wrap'>
                <span className='text-muted small'>Filter by group:</span>
                <button
                    className={`btn btn-sm ${groupFilter === '' ? 'btn-secondary' : 'btn-outline-secondary'}`}
                    onClick={() => setGroupFilter('')}
                >All</button>
                {(groups || []).map((g) => (
                    <button
                        key={g}
                        className={`btn btn-sm ${groupFilter === g ? 'btn-primary' : 'btn-outline-primary'}`}
                        onClick={() => setGroupFilter(g)}
                    >
                        {g}
                    </button>
                ))}
            </div>
            <table className='table table-sm table-border'>
                <thead className='border-0'>
                <tr>
                    <SortableTh label='Admin' field='auth' sort={sort} order={order} onSort={onSort}/>
                    <SortableTh label='Name' field='name' sort={sort} order={order} onSort={onSort}/>
                    <th>Description</th>
                    <SortableTh label='Group' field='group' sort={sort} order={order} onSort={onSort}/>
                    <SortableTh label='Method' field='method' sort={sort} order={order} onSort={onSort}/>
                    <SortableTh label='Route' field='route' sort={sort} order={order} onSort={onSort}/>
                    <th>Actions</th>
                </tr>
                </thead>

                <tbody>
                {data &&
                    data.data.map((permission) => (
                        <tr key={permission._id}>
                            <td>
                                {permission.auth ? (
                                    <span className='text-secondary' title='Admin — requires authentication'>
                                        <FaLock/> <small>Admin</small>
                                    </span>
                                ) : (
                                    <span className='badge bg-success'
                                          title='Public — no authentication required'>
                                        <FaLockOpen/> Public
                                    </span>
                                )}
                            </td>
                            <td>{permission.name}</td>
                            <td>{permission.description}</td>
                            <td>{permission.group || '—'}</td>
                            <td>
                                {renderMethodBadge('primary', 'GET', permission)}
                                {renderMethodBadge('success', 'POST', permission)}
                                {renderMethodBadge('warning', 'PUT', permission)}
                                {renderMethodBadge('danger', 'DELETE', permission)}
                            </td>
                            <td>{permission.route}</td>

                            <td>
                                <div className='btn-group'>
                                    <button
                                        className='btn'
                                        onClick={() => editHandler(permission)}
                                        data-bs-toggle='modal'
                                        data-bs-target='#permissionModal'
                                    >
                                        <img src={EditItemIcon} alt="Edit"
                                             className="icon-img action-icons-img"/>
                                    </button>

                                    <button
                                        className='btn'
                                        onClick={() => deleteHandler(permission._id)}
                                    >
                                        <img src={DeleteItemIcon} alt="Delete"
                                             className="icon-img action-icons-img"/>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default ViewPermissions;
